import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cart-stats" }
const _hoisted_2 = { class: "stats-item" }
const _hoisted_3 = { class: "item-title" }
const _hoisted_4 = { class: "item-value" }
const _hoisted_5 = { class: "stats-item" }
const _hoisted_6 = { class: "item-title" }
const _hoisted_7 = { class: "item-value bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('CartStats.selected')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.skins), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('CartStats.total')), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.totalNormalized), 1)
    ])
  ]))
}